import FetchHelper from '../../helpers/fetch_helper';
import { useEffect, useState } from 'react';
import PageSpinner from '../shared/page_spinner';
import Tradelines from '../admin/decisioning/Tradelines';
import Addresses from '../admin/decisioning/Addresses';

const BorrowerInfo = ({ customer, customerId }) => {
  const [borrowerInfo, setBorrowerInfo] = useState(null);
  useEffect(() => {
    if (!borrowerInfo) {
      (async () => {
        setBorrowerInfo(
          await FetchHelper.fetchJson(`customers/${customerId}/credit-checks/borrower-info`, { version: '/v3' })
        );
      })();
    }
  }, [borrowerInfo, customerId]);

  if (!borrowerInfo) {
    return <PageSpinner />;
  }

  const Akas = ({ akas, applicantType }) => (
    <div>
      <div>AKA(s)</div>
      <div className={`${applicantType === 'Primary' ? 'applicant' : 'coapp'}-akas`}>
        {(akas || [])
          .sort((a, b) => (a?.name < b?.name ? 1 : -1))
          .map((a) => a.name)
          .join(', ')}
      </div>
    </div>
  );

  const Applicant = ({
    id,
    customer,
    borrower: { cfirstName: borrFirstName, clastName: borrLastName, type, akas, addresses, tradelines },
  }) => {
    return (
      <div>
        <h3 style={{ padding: '0', margin: '0' }} className={'title'}>
          {type === 'Primary' ? 'Primary Applicant' : 'Co-Applicant'}
        </h3>
        <div
          id={id}
          style={{
            padding: '10px',
            marginRight: '10px',
            borderRadius: '10px',
            backgroundColor: 'rgba(255,255,255,0.7)',
          }}
        >
          <div className={'fullname'}>
            {customer?.cfirstname || borrFirstName} {customer?.clastname || borrLastName}
          </div>

          <div className={type === 'Primary' ? 'applicant-addresses' : 'coapp-addresses'}>
            <Addresses
              addresses={addresses}
              classNamePrefix={type === 'Primary' ? 'applicant-addresses' : 'coapp-addresses'}
            />
          </div>
          <div className={type === 'Primary' ? 'applicant-tradelines' : 'coapp-tradelines'}>
            <Tradelines
              locked={true}
              rows={tradelines}
              setRows={(a) => a}
              monthlyDebt={0}
              setMonthlyDebt={(a) => a}
              mini={true}
            ></Tradelines>
          </div>
          <Akas akas={akas} applicantType={type} />
        </div>
      </div>
    );
  };

  let sortedBorrowerInfo = (borrowerInfo || []).sort((a, b) => (a?.type > b?.type ? 1 : -1));

  return (
    <div className={'flex-container-max-row-min-col'} style={{}}>
      {sortedBorrowerInfo.map((app) => {
        return (
          <Applicant
            class={app.type === 'Primary' ? 'primary-applicant-info' : 'coprimary-applicant-info'}
            borrower={app}
            customer={customer}
          />
        );
      })}
    </div>
  );
};
export default BorrowerInfo;
